import { Pipe, PipeTransform } from '@angular/core';
import { DateRangeFilter, Filter, FilterTypes } from '@models/filter-types';

@Pipe({
    name: 'isDateRangeFilter',
    standalone: false,
})
export class IsDateRangeFilterPipe implements PipeTransform {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    transform(value: Filter<any>): value is DateRangeFilter {
        return value?.Type === FilterTypes.DateRangeFilterType;
    }
}
